import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ba427302&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ba427302&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba427302",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/lasur-lab/lasur-lab-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba427302')) {
      api.createRecord('ba427302', component.options)
    } else {
      api.reload('ba427302', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ba427302&scoped=true", function () {
      api.rerender('ba427302', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/broadcastGoodList/index.vue"
export default component.exports